<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_3"></a>Education of Character</h1>
<p class="subtitle">The Psychology of Children Going to School</p>
<p class="author">Bertrand Russell</p>
<div class="img_container1">
<img alt="image" src="images/fig_03.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?66f15e5b